module.exports = __webpack_public_path__ + "static/img/white_wrinkled_silk_blue_1440x1190.eec3b03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/white_wrinkled_silk_blue_1440x1190.jpg
// module id = YXn1
// module chunks = 0